module.exports = __webpack_public_path__ + "img/ana-sayfa.0babc815.png";